import { render, staticRenderFns } from "./MarksCalendarView.vue?vue&type=template&id=72c10177"
import script from "./MarksCalendarView.vue?vue&type=script&lang=js"
export * from "./MarksCalendarView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports